// https://docs.google.com/spreadsheets/d/1ew8WkBtMan8rTrk12k4-WuJbzkKeuDZqUsHywBxjyPk/edit#gid=0

export const SERVICE_GTM_IDS = {
	expressRepair: 'gtm-ekspress-remont',
	orderPartsBeforeRepair: 'gtm-zakaz-zapchasti-do-remonta',
	helperBlockAction: 'gtm-ostavit-zayavku-footer',
	serviceFormSubmitButton: 'gtm-service-request-push'
}

export const SERVICE_YA_METRICS_IDS = {
	expressRepair: 'ekspress-remont',
	orderPartsBeforeRepair: 'zakaz-zapchasti-do-remonta',
	helperBlockAction: 'ostavit-zayavku-footer',
	serviceFormSubmitButton: 'service-request-push'
}
